function sectionsSubPopup(){
    const items = document.querySelectorAll('.sections-sub-popup__item');
    items.forEach(item => item.addEventListener('click', (e) => {
        const itemTextContainer = e.currentTarget.querySelector('.sections-sub-popup__text-container');

        if (itemTextContainer) {
            // клик на мобильном - показывает подразделы
            if (window.innerWidth > 575 && window.innerWidth <= 991) {
                itemTextContainer.classList.add('sections-sub-popup__text-container_active');
            }

            // на маленьком экране при клике - сразу переход в раздел без показа подразделов
            if (window.innerWidth <= 575) {
                document.location.href = itemTextContainer.querySelector('.sections-sub-popup__title').getAttribute('href');
            }
        }
    }));
}

export default sectionsSubPopup;